import { graphql, useStaticQuery } from "gatsby"
import { useLocation } from "@reach/router"
import React, { ReactNode } from "react"

interface Props {
  description?: string
  lang?: string
  meta?: any[]
  title: string
  isApp?: boolean
  siteUrl?: string
  ogImage?: string
  type?: string
  path?: string
  children?: ReactNode
}

export default ({
  description = "",
  lang = "ja",
  title,
  ogImage,
  children
  }: Props) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  )

  const location = useLocation();
  const metaDescription = description || site.siteMetadata.description
  const ogUrl = `https://pharms-cloud.com${location.pathname}`

  return (
    <>
      <html lang={lang} prefix="og: https://ogp.me/ns#" />
      <title>{`${title} | ${site.siteMetadata.title}`}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage || `https://pharms-cloud.com/images/ogp/ogp.png`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata.author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      {children}
    </>
  )
}
